import React, {useCallback, useMemo,} from 'react';
import {Dialog as MuiDialog, Paper, useMediaQuery} from '@mui/material';
import classnames from "classnames";
import {ReactComponent as CloseIcon} from "../../../../assets/images/dialog-close-icon.svg";

const PaperComponent = ({
                            onCloseClick,
                            extraClassName,
                            role,
                            className,
                            loading,
                            closeDisabled,
                            fullScreen,
                            ...rest
                        }) => {
    /**
     * No operation function
     * @type {function()}
     */
    const noop = useCallback(() => void 0, []);

    return (
        <>
            <div className={classnames('d-flex flex-column dialog-paper-container', className, {'fullscreen': fullScreen})} role={role}>
                {
                    !closeDisabled &&
                    <div className={classnames('dialog-close-container', {'fullscreen': fullScreen})}>
                        <CloseIcon
                            onClick={(e) => loading ? noop : onCloseClick(e)}
                            className={'close-icon'}
                        />
                    </div>
                }
                <Paper {...{...rest, className: classnames(rest.className, 'dialog-paper', {[extraClassName]: !!extraClassName?.length})}}/>
            </div>
        </>

    );
}

const Dialog = ({
                    open,
                    setOpen,
                    disableBackdropClick = false,
                    disableEscapeKeyDown = false,
                    loading = false,
                    maxWidth = 'sm',
                    fullWidth = true,
                    fullScreen = undefined,
                    scroll = 'paper',
                    children,
                    className = '',
                    ...props
                }) => {
    const closeDisabled = useMemo(() => loading || (disableBackdropClick && disableEscapeKeyDown), [loading, disableBackdropClick, disableEscapeKeyDown])
    // TODO: fix all the dialogs to allow for fullscreen mode in phone views.
    const isInPhoneView = useMediaQuery(theme => theme.breakpoints.down('md'));
    const fullscreenInterpolated = useMemo(() => fullScreen ?? false, [fullScreen]);

    /**
     * Closes the dialog based on the reason
     * @type {(function(*, *): void)}
     */
    const onClosed = useCallback((_, reason) => {
        switch (reason) {
            case "backdropClick":
                if (!disableBackdropClick && !loading)
                    setOpen?.(false);
                break;
            case "escapeKeyDown":
                if (!disableEscapeKeyDown && !loading)
                    setOpen?.(false);
                break;
            default:
                break;
        }
    }, [disableBackdropClick, disableEscapeKeyDown, loading, setOpen]);

    /**
     * Closes the dialog
     * @type {function(): void}
     */
    const onCloseClick = useCallback(() => setOpen?.(false), [setOpen])

    return (
        <MuiDialog
            onClose={onClosed}
            PaperComponent={PaperComponent}
            PaperProps={{
                onCloseClick,
                loading,
                extraClassName: className,
                closeDisabled,
                fullScreen: fullscreenInterpolated,
            }}
            maxWidth={maxWidth}
            fullScreen={fullscreenInterpolated}
            scroll={scroll}
            fullWidth={fullWidth}
            open={open}
            {...props}
        >
            {children}
        </MuiDialog>
    );
}

export default Dialog;
